import { wrapRetry } from '@perpay-web/utils/importUtils';

export const importPerpayPlusSoloApplicationContainer = () =>
    wrapRetry(
        () =>
            import(
                /* webpackChunkName: "PerpayPlusSoloApplicationContainer" */
                '@perpay-web/fintech/components/containers/PerpayPlusSoloApplicationContainer'
            ),
    );
